import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function HotMovies() {
  return (
    <section className="py-8 md:py-10" aria-label="热门推荐">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-100">
              热门推荐
            </h2>
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500/20 text-accent-400">
              热播中
            </span>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
          >
            更多热门
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {hotMovies.slice(0, 6).map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}